import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';

import { Utils, NumberFormatter, isAuth, domainVal, i18n, DateFormatter } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import CompagnieActions from './CompagnieActions';
import Bisogno from './bisogno.jsx';
import { AppConstants } from '../../constants/AppConstants';
import CompagniaTable from './compagniaTable.jsx';
import SwitchButton from '../shared/switchButtonV4.jsx';

class CompagnieList extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CompagnieList.jsx] ';
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.salvaCompagnia = this.salvaCompagnia.bind(this);
        this.annullaOnClick = this.annullaOnClick.bind(this);
        this.nuovoCompagnia = this.nuovoCompagnia.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.modificaCompagnia = this.modificaCompagnia.bind(this);
        this.state = {
            showConfirmCompagnia: false,
            validation: new Map()
        }
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //effettuo la chimata rest per recuperare i dati
        this.props.getListCompagnie();
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');


    }

    modificaCompagnia(id) {
        console.log(this.componentName + "modificaCompagnia: " + id);
        this.props.inizializzaModificaCompagnia(id);
        this.showConfirmPanel();
    }

    nuovoCompagnia() {
        console.log(this.componentName + "nuovoCompagnia: ");
        this.props.inizializzaNuovoCompagnia();
        this.showConfirmPanel();
    }

    annullaOnClick() {
        this.showConfirmPanel();

        this.props.inizializzaNuovoCompagnia();

    }


    showConfirmPanel() {
        this.props.showPopUP(!this.props.showConfirmCompagnia);
    }


    salvaCompagnia() {
        console.log(this.componentName + 'salvaCompagnia');

        if (!this.validateForm()) {
            return;
        }
        this.showConfirmPanel();

        this.props.salvaCompagnia().then(

            resolve => {
                this.props.getListCompagnie();
            }
        )



    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['denominazione', 'codIsVap'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.compagnia[required[i]] === undefined || this.props.compagnia[required[i]] === '' || this.props.compagnia[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            // this.setState({ showConfirm: !this.state.showConfirm });
            this.showConfirmPanel();
            return true;
        }
        // $("#modalConfirm").modal("close");

        return false;
    }

    inputChangeHandler(e) {

        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + "inputChangeHandler:" + id);

            let type = e.target.type;

            if (type === "number" && value === "") {
                value = null;
            }

            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }


            this.props.inputChangeHandlerCompagnia(id, value);
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card">
                <div className="card-header">
                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                        <agui.aButton className="float-right" bs='primary' onClick={this.nuovoCompagnia} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVA', 'Nuova')} </agui.aButton>
                    }
                    <h3>{i18n('ARM_CORE_PRODUCT.COMPAGNIA.LISTA_COMPAGNIE', 'Lista Compagnie')}</h3>
                </div>
                <div className="card-body">

                    <CompagniaTable modificaCompagnia={this.modificaCompagnia} rows={this.props.compagnie} history={this.props.history}></CompagniaTable>

                </div>
                <agui.ConfirmModalOkCancelV4 show={this.props.showConfirmCompagnia} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle={this.props.compagnia.id ? i18n('ARM_CORE_PRODUCT.MODIFICA','Modifica') : i18n('ARM_CORE_PRODUCT.CREAZIONE','Creazione')} onClose={this.showConfirmPanel} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="denominazione" type="text"
                                    value={this.props.compagnia && this.props.compagnia.denominazione}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.DENOMINAZIONE', 'Denominazione')}
                                    onChange={this.inputChangeHandler}
                                    validation={this.state.validation}
                                    required
                                    name="denominazione"
                                />
                            </div>
                        </div>
                        {/* <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id={"tipo"} type="text"
                                    value={this.props.compagnia && this.props.compagnia.tipo}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.TIPO', 'Tipo')}
                                    validation={this.state.validation}
                                    onChange={this.inputChangeHandler}
                                    name="tipo"
                                />
                            </div>
                        </div> */}

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id={"codIsVap"} type="text"
                                    value={this.props.compagnia && this.props.compagnia.codIsVap}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.CODICE_IVASS', 'Codice IVASS')}
                                    validation={this.state.validation}
                                    onChange={this.inputChangeHandler}
                                    required
                                    name="codIsVap"
                                />
                            </div>

                        </div>
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id={"codAnia"} type="number"
                                    value={this.props.compagnia && this.props.compagnia.codAnia}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.CODICE_ANIA', 'Codice Ania')}
                                    onChange={this.inputChangeHandler}
                                    required={false}
                                    name="codAnia"
                                />
                            </div>
                        </div>

                        <div className="row mt-1">
                            <SwitchButton
                                id="flCompagniaEstera"
                                label={i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA_ESTERA', 'Compagnia Estera')}
                                value={this.props.compagnia.flCompagniaEstera === "true" || this.props.compagnia.flCompagniaEstera === true}
                                onChange={this.inputChangeHandler}
                            />
                        </div>

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer  testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoButtonCancel={i18n('ARM_CORE_PRODUCT.SHARED.ANULLAA', 'Anulla')}
                        confirmOnClick={this.salvaCompagnia} onClose={this.annullaOnClick}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListCompagnie() {
            return dispatch(CompagnieActions.getListCompagnie());
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        inputChangeHandlerCompagnia(id, value) {
            return dispatch(CompagnieActions.handleChange(id, value));
        },

        salvaCompagnia() {
            return dispatch(CompagnieActions.salvaCompagnia());
        },

        inizializzaNuovoCompagnia() {
            return dispatch(CompagnieActions.inizializzaNuovoCompagnia());
        },

        inizializzaModificaCompagnia(id) {
            return dispatch(CompagnieActions.inizializzaModificaCompagnia(id));
        },

    }
};

function mapStateToProps(state) {
    return {
        compagnie: state.compagnie.listaCompagnie,
        showConfirmCompagnia: state.app.showPopUp,
        compagnia: state.compagnie.compagnia,

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CompagnieList);
